import React from 'react';
import { Box, Circle } from '@televet/kibble-ui/build/chakra';
import { Button } from '@televet/kibble-ui/build/components/Button';

interface IFilterIconButtonProps {
  badgeCount?: number;
  showBadge?: boolean;
  buttonProps?: Record<string, unknown>;
  onFilterToggle: () => void;
}

const FilterIconButton = React.forwardRef<HTMLButtonElement, IFilterIconButtonProps>(
  ({ showBadge, badgeCount, buttonProps, onFilterToggle, ...rest }: IFilterIconButtonProps, ref): JSX.Element => {
    return (
      <Box position="relative" {...rest}>
        {showBadge || (badgeCount && badgeCount > 0) ? (
          <Circle bg="background.secondary" size={3} pos="absolute" top={1} right={1}>
            {badgeCount || ''}
          </Circle>
        ) : null}
        <Button
          {...buttonProps}
          iconName="filter"
          onClick={onFilterToggle}
          size="md"
          variant="ghostNeutral"
          ref={ref}
        />
      </Box>
    );
  },
);

FilterIconButton.displayName = 'FilterIconButton';

export default FilterIconButton;
